// export {}; 

export interface EstadoLiquidacion {
  id: number;
  texto: string;
  color: string;
}
  
export const estadoLiquidacion: EstadoLiquidacion[] = [
  { id: 1, texto: 'Abierto', color: '#EDF3F6' }, // Neutro
  { id: 2, texto: 'Finalizado', color: '#FBE6BC' }, // Ambar
  { id: 3, texto: 'Liquidado', color: '#DBE5EE' }, // Azul acero
  { id: 4, texto: 'Cancelado', color: '#E1E6E9' }, // Gris
];